import React from "react";

export default function CompoundDetiles({ open, onClose, userData }) {
  if (!open) return null;

  const compounds = userData?.Compound ? Object.entries(userData.Compound) : [];

  return (
    <div style={styles.backdrop} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h2 style={styles.title}>Registered Compound</h2>
          <button style={styles.closeBtn} onClick={onClose}>
            ✕
          </button>
        </div>

        {compounds.length === 0 ? (
          <p style={styles.noData}>No compound data found.</p>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>S/N</th>
                <th style={styles.th}>State</th>
                <th style={styles.th}>LGA</th>
                <th style={styles.th}>Community</th>
                <th style={styles.th}>Compound Name</th>
                <th style={styles.th}>Street</th>
                <th style={styles.th}>Occupant Status</th>
                <th style={styles.th}>House Image</th>
                <th style={styles.th}>Location Type</th>
                <th style={styles.th}>Address Coordinates</th>
              </tr>
            </thead>
            <tbody>
              {compounds.map(([id, compound], index) => (
                <tr key={id}>
                  <td style={styles.td}>{index + 1}</td>
                  <td style={styles.td}>{compound.state}</td>
                  <td style={styles.td}>{compound.localGovtArea}</td>
                  <td style={styles.td}>{compound.community}</td>
                  <td style={styles.td}>{compound.name}</td>
                  <td style={styles.td}>{compound.street}</td>
                  <td style={styles.td}>{compound.owner}</td>
                  <td style={styles.td}>
                    {compound.imgHouse ? (
                      <a href={compound.imgHouse} target="_blank" rel="noopener noreferrer">
                        <img src={compound.imgHouse} alt="House" style={styles.houseImg} />
                      </a>
                    ) : (
                      "No Image"
                    )}
                  </td>
                  <td style={styles.td}>
                    {compound.locationType || compound.type || compound.typeLocation || "—"}
                  </td>
                  <td style={styles.td}>
                    {(() => {
                      const link = compound.location || compound.addressCoordinates || compound.coordinates || compound.mapUrl;
                      const latLng = (compound.lat && compound.lng) ? `${compound.lat},${compound.lng}` : (compound.latitude && compound.longitude ? `${compound.latitude},${compound.longitude}` : null);
                      
                      const finalLoc = link || latLng;
                      if (!finalLoc) {
                         // Temporary debug info for the user so we can see the exact field names
                         return <span style={{fontSize: '10px', color: 'gray'}}>Keys: {Object.keys(compound).join(', ')}</span>;
                      }
                      
                      const href = finalLoc.startsWith('http') ? finalLoc : `https://www.google.com/maps?q=${finalLoc}`;
                      return (
                        <a 
                          href={href} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{ color: "#1C87F9", textDecoration: "none", wordBreak: "break-all" }}
                        >
                          {href}
                        </a>
                      );
                    })()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },

  modal: {
    backgroundColor: "#fff",
    width: "1050px", // Increased width to fit all columns nicely
    maxWidth: "95vw",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    overflowX: "auto", // Added horizontal scroll if content overflows
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },

  title: {
    margin: 0,
    fontSize: "20px",
    fontWeight: 600,
  },

  closeBtn: {
    background: "none",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  th: {
    padding: "10px 12px",
    borderBottom: "2px solid #ddd",
    backgroundColor: "#f8f8f8",
    fontWeight: 600,
    fontSize: "14px",
    color: "black",
  },

  td: {
    padding: "10px 12px",
    borderBottom: "1px solid #eee",
    fontSize: "14px",
  },

  tr: {
    backgroundColor: "#fff",
  },
  noData: {
    fontSize: "16px",
    color: "black",
    padding: "20px",
  },
  houseImg: {
    width: "60px",
    height: "45px",
    objectFit: "cover",
    borderRadius: "4px",
    cursor: "pointer",
    border: "1px solid #ddd",
  },
};
